import React, { useEffect, useRef, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled, { css, ThemeProvider } from 'styled-components';

import Close from '../icons/Close';
import theme from '../../../styles/theme';

const CloseButton = styled(Close)`
  align-self: flex-end;
  margin-bottom: 1;
  margin-right: -50px;

  @media (max-width: 900px) {
    display: none;
  }
`;

const CloseMobile = styled(Close)`
  display: none;
  position: absolute;
  top: 24px;
  right: 24px;
  margin-right: 0;

  @media (max-width: 900px) {
    display: block;
  }
`;

const Video = styled.iframe.attrs({ frameborder: 0 })`
  border: none;
  height: 100%;

  @media (max-width: 900px) {
    margin-top: 49px;
    height: calc(100% - 49px);
    width: 100%;
  }

  @media ${p => p.theme.media.largePhone} {
    height: auto;
    width: 100%;
  }
`;

const Overlay = styled.div`
  position: fixed;
  z-index: 2147483641; /* cover the feedback button */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ${p => (p.isOpen ? 'ease-in' : 'ease-out')};
  justify-content: center;
  background-color: #000;

  ${p =>
    p.isOpen &&
    css`
      visibility: visible;
      opacity: 1;
    `};
`;

const VideoContainer = styled.div`
  margin-top: 70px;
  width: 75%;
  height: 75%;
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    width: 100%;
    height: auto;
    margin: 0 28px;
    align-items: center;
    justify-content: center;
  }
`;

const VideoOverlay = ({ id, show, toggleOverlay, isVimeo = false }) => {
  const portal = useRef();
  if (typeof document !== 'undefined') {
    portal.current = document.getElementById('videoOverlay');
  }

  useEffect(() => {
    if (portal.current) {
      ReactDOM.render(
        show ? (
          <ThemeProvider theme={theme}>
            <Overlay isOpen={show}>
              <VideoContainer>
                <CloseMobile click={toggleOverlay} size={24} />
                <CloseButton click={toggleOverlay} size={40} />
                {show && (
                  <Video
                    src={
                      isVimeo
                        ? `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0`
                        : `https://www.youtube.com/embed/${id}?modestbranding=1&rel=0`
                    }
                  />
                )}
              </VideoContainer>
            </Overlay>
          </ThemeProvider>
        ) : (
          Fragment
        ),
        portal.current
      );
    }
  }, [show]);

  return Fragment;
};

VideoOverlay.propTypes = {
  id: PropTypes.string,
  show: PropTypes.bool,
  toggleOverlay: PropTypes.func.isRequired,
  isVimeo: PropTypes.bool
};

export default VideoOverlay;
